import React from "react";

export default function ApplicationFacet({
  handleFilterClick,
  productApplications, // full list from initial load
  productApplicationsDynamic, // updated counts from backend
  selectedApplications = [],
}) {
  const sortObject = (obj) =>
    Object.keys(obj)
      .sort()
      .reduce((sorted, key) => {
        sorted[key] = obj[key];
        return sorted;
      }, {});

  const sortedApplications = sortObject(productApplications || {});

  const isChecked = (value) =>
    selectedApplications.includes(value.toLowerCase());

  const handleCheckbox = (value) => {
    handleFilterClick("application_facet", value.toLowerCase());
  };
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("application_facet") &&
    plpFacetLabel.application_facet != ""
      ? plpFacetLabel.application_facet
      : "Application";

  return (
    <div className="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(sortedApplications).map((application, i) => {
          const originalCount = sortedApplications[application];
          const currentCount = productApplicationsDynamic?.[application] ?? 0;
          const isSelected = isChecked(application);

          return (
            <div key={i} className="facet-option">
              <label
                className="facet-label"
                style={{
                  fontWeight: isSelected ? "bold" : "normal",
                  color: isSelected ? "#000" : "#666",
                }}>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleCheckbox(application)}
                  className="facet-checkbox"
                />
                <span className="facet-text">
                  {application} ({currentCount})
                </span>
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}
